import { useRoute } from 'vue-router/composables'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { superstoryTrack } from '@/track'
import { api } from '@/api'
import { useToastStore, useUserStore } from '@/stores'
import { useElementClick } from '@/composables/tracks/useElementClick'
import { t } from '@/i18n/utils'
import { features } from '@/config/brands'
import { tripartiteLoginPage } from '@/composables/useTripartiteLogin'

export function useBookshelf(book: Ref<{ id: string } | undefined>) {
  const route = useRoute()
  const user = useUserStore()
  const { $toast } = useToastStore()
  const { elementClick } = useElementClick()
  const isInShelf = ref(false)
  const shelfLoading = ref(false)

  async function toggle() {
    if (!book.value || shelfLoading.value)
      return

    const next = !isInShelf.value
    if (next)
      superstoryTrack('add_library_button_ck', { book_id: book.value.id, source: route.name === 'book' ? 'book_detail' : 'reader' })
    shelfLoading.value = true
    try {
      if (next) {
        if (features?.requireLoginToAddBookshelf) {
          // 游客也持有 token；以邮箱或第三方绑定信息判断正式登录状态。
          await user.init()
          if (!user.$state.thirdPartType && !user.$state.email) {
            await tripartiteLoginPage('AddToLibrary')
            return
          }
        }
        await api.post<any, PostBookshelfAddResponse>('/bookshelf/add', { contentId: book.value.id })
        elementClick('add_shelf')
        $toast(t('BookshelfAddSuccess'))
      }
      else {
        await api.post<any, PostBookshelfDelResponse>('/bookshelf/del', { contentIds: [book.value.id] })
        elementClick('remove_shelf')
      }
      isInShelf.value = next
    }
    finally {
      shelfLoading.value = false
    }
  }

  return { isInShelf, shelfLoading, toggle }
}
